/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Enable_Accounting_CodesInputs */

const en_admin_resource_form_enable_accounting_codes = /** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable accounting codes`)
};

const de_admin_resource_form_enable_accounting_codes = /** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungscodes aktivieren`)
};

const es_admin_resource_form_enable_accounting_codes = /** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar los códigos de contabilidad`)
};

const fr_admin_resource_form_enable_accounting_codes = /** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les codes de facturation`)
};

/** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */
const it_admin_resource_form_enable_accounting_codes = en_admin_resource_form_enable_accounting_codes;

/** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */
const pt_br2_admin_resource_form_enable_accounting_codes = en_admin_resource_form_enable_accounting_codes;

/** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */
const pl_admin_resource_form_enable_accounting_codes = en_admin_resource_form_enable_accounting_codes;

/** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */
const hu_admin_resource_form_enable_accounting_codes = en_admin_resource_form_enable_accounting_codes;

/** @type {(inputs: Admin_Resource_Form_Enable_Accounting_CodesInputs) => LocalizedString} */
const ro_admin_resource_form_enable_accounting_codes = en_admin_resource_form_enable_accounting_codes;

/**
* | output |
* | --- |
* | "Enable accounting codes" |
*
* @param {Admin_Resource_Form_Enable_Accounting_CodesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_enable_accounting_codes = /** @type {((inputs?: Admin_Resource_Form_Enable_Accounting_CodesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Enable_Accounting_CodesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_enable_accounting_codes(inputs)
	if (locale === "de") return de_admin_resource_form_enable_accounting_codes(inputs)
	if (locale === "es") return es_admin_resource_form_enable_accounting_codes(inputs)
	if (locale === "fr") return fr_admin_resource_form_enable_accounting_codes(inputs)
	if (locale === "it") return it_admin_resource_form_enable_accounting_codes(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_enable_accounting_codes(inputs)
	if (locale === "pl") return pl_admin_resource_form_enable_accounting_codes(inputs)
	if (locale === "hu") return hu_admin_resource_form_enable_accounting_codes(inputs)
	return ro_admin_resource_form_enable_accounting_codes(inputs)
});
export { admin_resource_form_enable_accounting_codes as "admin.resource_form.enable_accounting_codes" }